import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RequestStatus } from "common/enums/requestStatus";
// import { fetch } from "core/Api";
import IUser from "common/interfaces/IUser";
import { fetch } from "core/Api";
import { loginUser } from "core/Auth";

interface auth {
  userId?: string;
  access_token?: string;
}

interface IUserState {
  auth: auth;
  info: IUser | null;
  status: RequestStatus;
  error: any;
}

const initialState: IUserState = {
  auth: {},
  info: null,
  status: RequestStatus.IDLE,
  error: null,
};

export const login = createAsyncThunk(
  "user/login",
  async (credentials: { email: string; password: string }) => {
    try {
      return await loginUser(credentials);
    } catch (e: any) {
      return console.error(e.messages);
    }
  }
);

export const getUser = createAsyncThunk(`user/info`, async (id: string) => {
  try {
    return await fetch(`/users/${id}`);
  } catch (e: any) {
    return console.error(e.messages);
  }
});

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logout: (state) => {
      state = initialState;
    },
    setAuth: (state, action) => {
      state.auth = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.pending, (state, action) => {
      state.status = RequestStatus.PENDING;
    });
    builder.addCase(login.fulfilled, (state, action) => {
      state.status = RequestStatus.SUCCEEDED;
      state.auth.access_token = action.payload.access_token;
      state.auth.userId = action.payload.userId;
    });
    builder.addCase(login.rejected, (state, action) => {
      state.status = RequestStatus.FAILED;
      state.error = action.error.message;
    });

    builder.addCase(getUser.pending, (state, action) => {
      state.status = RequestStatus.PENDING;
    });
    builder.addCase(getUser.fulfilled, (state, action) => {
      state.status = RequestStatus.SUCCEEDED;
      // remove the type any when the api is ready
      state.info = action.payload as any;
    });
    builder.addCase(getUser.rejected, (state, action) => {
      state.status = RequestStatus.FAILED;
      state.error = action.error.message;
    });
  },
});

export const { logout, setAuth } = userSlice.actions;

export default userSlice.reducer;
